import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteAddTourProgramForm } from "../../../data/usecases/monthly-tour-program/remote-add-tour-program-form";
import { AddTourProgramForm } from "../../../domain/useages/monthly-tour-program/addTourProgramForm";

export interface AddTourProgramFormInterface {
 AddTourProgramFormState: FetchState;
 addTourProgramForm: Function;
}

const initialStates = {
 AddTourProgramFormState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddTourProgramFormSlice: StateCreator<
  AddTourProgramFormInterface
> = (set) => ({
  ...initialStates,
    addTourProgramForm: async (payload: AddTourProgramForm.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddTourProgramForm = new RemoteAddTourProgramForm(
      `${BASE_URL}${Endpoints.ADD_TOUR_PROGRAM_FORM}`,
      axiosHttpClient
    );

    set(() => ({ AddTourProgramFormState: FetchState.LOADING }));
    let result = await remoteAddTourProgramForm.add(payload);
    return result;
  },
});
